import type {BaseComponentConfig, BitmapText, SlotGameStore} from "@gamzix/slot_core";
import {CONST} from "../../../src/const";

const SymbolView = ReelsetComponent.src.SymbolView;

class CoinAnimationComponent extends Game.src.component.BaseComponent {
    static events = {
        FLY_FINISH: "CoinAnimationComponent.FLY_FINISH",
        FLY_START: "CoinAnimationComponent.FLY_START",
        ANIMATE_FINISHED: 'COIN_ANIMATE_FINISHED'
    }

    protected TIME_MOVE = 250;
    protected TIME_DELAY_BEFORE_MOVE = 250;

    protected isShowing = false;
    protected totalWinCounter;

    protected reelset;

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isShowing: () => this.isShowing
        }
    }

    onGameReady() {
        super.onGameReady();

        //@ts-ignore
        this.reelset = game.component.reelset;

        this.totalWinCounter = game.tree.findByName('ui.win_label');
    }

    async playCoinAnimation(label, {time, fromElement, toElement, onStart, onFinish}) {
        function setOverlayImage(textureName, view) {
            const overlayView: any = game.builder.create({type: "Sprite", texture: textureName, scale: {x: 1, y: 1}});
            overlayView.options.visible = false;
            overlayView.updateViewOptions();
            view.addChild(overlayView);

            return overlayView;
        }

        let text;

        if ([CONST.JACKPOT.GOLD.name, CONST.JACKPOT.SILVER.name, CONST.JACKPOT.BRONZE.name].includes(label)) {
            text = setOverlayImage(`coin_${label}`, this.view);
        } else {
            text = <BitmapText>game.builder.create(this.options.config.coinTextConfig);
            text.options.text = label;
            text.visible = false;
            text.setText(label);
            this.view.addChild(text);
        }

        await game.utils.GameUtils.playMoveAnimation(text, {
            fromElement: fromElement,
            toElement: toElement,
            time: time,
            onStart: () => {
                onStart();
                text.visible = true
            },
            onFinish: () => {
                onFinish();
                text.visible = false
            }
        })

        await game.utils.delay(0);
        game.utils.PIXIUtils.remove(text);
    }

    async startCoinAnimation(): Promise<void> {
        for (const cluster of this.store.gameData.bonusGame.extra?.clusters) {
            // for correct animation sequence
            cluster.sort((a, b) => {
                // First sort by key Y
                if (a.y !== b.y) {
                    return a.y - b.y;
                }

                // Then sort by key X, if Y is equal
                return a.x - b.x;
            });

            for (const { x, y } of cluster) {
                const symbolData = this.store.gameData.reels[x][y];
                const symbol = this.reelset.getReel(x).getSymbol(y);

                const coinValue = symbolData.value * this.store.gameData.bet;
                let value = this.store.toFormatMoney(coinValue);

                if (symbolData.value == CONST.JACKPOT.GOLD.multiplier) {
                    value = CONST.JACKPOT.GOLD.name;
                }

                if (symbolData.value == CONST.JACKPOT.SILVER.multiplier) {
                    value = CONST.JACKPOT.SILVER.name;
                }

                if (symbolData.value == CONST.JACKPOT.BRONZE.multiplier) {
                    value = CONST.JACKPOT.BRONZE.name;
                }


                await game.utils.delay(this.TIME_DELAY_BEFORE_MOVE);

                await this.playCoinAnimation(value, {
                    time: this.TIME_MOVE,
                    fromElement: symbol,
                    toElement: this.totalWinCounter,
                    onStart: () => {
                        symbolData.value = null;
                        symbol.removeOverlayView();
                        game.emit(CoinAnimationComponent.events.FLY_START);
                    },
                    onFinish: () => {
                        this.store.gameData.visualWinAmount += coinValue;
                        game.emit('UI.UPDATED');
                        game.emit(CoinAnimationComponent.events.FLY_FINISH);
                        this.onChangeOrientation();
                    }
                });
            }
        }

        game.emit(CoinAnimationComponent.events.ANIMATE_FINISHED);
    }

    async show() {
        this.isShowing = true;

        this.onChangeOrientation();
    }

    async hide() {
        this.isShowing = false;

        this.onChangeOrientation();
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    getFSMHandlers(): any {
        return {
            SPIN: {
                exit: {
                    on: async () => {
                        if (this.store.gameData.bonusGame.isFinished()) {
                            this.reelset.showBonusCluster();

                            await this.show();
                            await this.startCoinAnimation();

                            await this.hide();
                        }
                    }
                }
            }
        }
    }
}

export {CoinAnimationComponent}

//@ts-ignore
Game.src.component.CoinAnimationComponent = CoinAnimationComponent;